module.exports = __webpack_public_path__ + "img/9791158882402.f473e3d3.jpg";